// app/javascript/compcalc/components/CombinedValue.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import withErrorHandling from './ErrorHandling';
import ComboBoxList from './utils/ComboBoxList';
import ItemArrayList from './utils/ItemArrayList';
import { currencyFormatter, formatShortDate, isValidDate, toDate, saveAsFile, sendMail } from '../utils'
import { combineRatings, getRatingsString } from '../rating_utils'

const styles = theme => ({
  root: {
    // flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(1),
  },
  inputLabel: {
    fontSize: 22,
    // fontWeight: 'bold',
    // marginBottom: theme.spacing(1), // TODO: margin not working.
  },
  dateField: {
    width: 150,
  },
  group: {
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  listItem: {
    // height: '80% !important',
  },
  textFieldDense: {
    margin: 0,
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',        // Vertical align.
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  wrapContent: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  wrapContent1: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 2,
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class CombinedValue extends React.PureComponent {

  constructor(props) {
    super(props);
    // console.log('CombinedValue.constructor()');

    this.itemsWPI = [];
    for (let i = 0; i < 100; ++i) {
      this.itemsWPI.push(
        <MenuItem dense key={'percent' + i} value={i}>{i}%</MenuItem>
      );
    }

    this.itemsApport = [];
    for (let i = 0; i <= 100; ++i) {
      this.itemsApport.push(
        <MenuItem dense key={'percent' + i} value={i}>{i}%</MenuItem>
      );
    }

    this.minDOB = new Date('1900-01-01T12:00');
    this.minDOI = new Date('1996-01-01T12:00');
    this.maxDOI = new Date('2024-12-31T12:00');
    this.unknownRatingString = 'WPI - DFEC - OCC - AGE - ? %PD';

    this.pdRateMaxText = 'PD Rate (maximum)';
    this.pdRateMinText = 'PD Rate (minimum)';
    this.pdRateText = 'PD Rate';

    this.initialState = {
      doi: new Date('2015-01-01T12:00'),

      inputAww: false,

      pdRateText: this.pdRateMaxText,
      aww: currencyFormatter.format(0),
      pdRate: currencyFormatter.format(0),

      currentRating: 0,
      ratings: [ 50 ],

      combinedValue: 0.0,
      amount: 0,
    };
    this.state = { ...this.initialState };
  }

  componentDidMount = () => {
    // console.log('CombinedValue.componentDidMount()')
    this.props.setChildMenuHandler(this.handleMenu);
    this.calculate();
  }

  componentWillUnmount = () => {
    this.props.setChildMenuHandler(undefined);
  }

  fetchPermDisResult = (afterFunc) => {
    // console.log('fetchPermDisResult', this.state.currentRating, this.state.ratings);
    let aww = this.state.inputAww ? currencyFormatter.parse(this.state.aww) : 0.0;
    let url = `api/v1/permanent_disability.json?disability=${this.state.combinedValue}&date=${formatShortDate(this.state.doi)}&aww=${aww}`;
    this.props.fetch(url, result => {
      afterFunc(result);
    }).catch(e => this.props.showError(e, 'Error obtaining permanent disability amounts'));
  }

  // --------------------- Selection changed events ---------------------
  onDateOfInjuryChanged = (date) => {
    if (!isValidDate(date)) { return; }
    // let date = toDate(dateString);
    if (date < this.state.dob)
      date = this.state.dob;
    if (date < this.minDOI)
      date = this.minDOI;
    // console.log(`onDateOfInjuryChanged: ${this.state.dob} ${date}`);
    this.setState({
      doi: date
    }, this.calculate);
  }

  onRatingIndexChanged = (index, wpi) => {
    this.setState({ currentRating: index });
  }

  onRatingChanged = (index, wpi) => {
    let ratings = [ ... this.state.ratings ];
    ratings[index] = wpi;
    this.setState({
      ratings: ratings,
    }, this.calculate);
  }

  onInputAwwChanged = (checked) => {
    if (this.state.inputAww == checked) { return; }
    this.setState({
      inputAww: checked
    }, () => this.fetchPermDisResult(this.showResult));
  }

  onAwwChanged = (value) => {
    if (!this.state.inputAww) return;
    let aww = currencyFormatter.parse(value);
    let pdRate = aww * 2.0/3.0;
    // console.log(`onAwwChanged(): ${aww}`);
    this.setState({
      aww: currencyFormatter.format(aww),
      pdRate: currencyFormatter.format(pdRate),
    }, () => this.fetchPermDisResult(this.showResult));
  }

  onPdRateChanged = (value) => {
    if (!this.state.inputAww) return;
    let pdRate = currencyFormatter.parse(value);
    // console.log(`onPdRateChanged(): ${pdRate}`);

    let aww = pdRate * 3.0/2.0;
    this.setState({
      aww: currencyFormatter.format(aww),
      pdRate: currencyFormatter.format(pdRate),
    }, () => this.fetchPermDisResult(this.showResult));
  }

  // --------------------- Menu functions ---------------------
  handleMenu = (menu, submenu) => {
    // console.log(`handleMenu: menu = ${menu}, submenu = ${submenu}`);
    switch (submenu) {
      case 'add':
        this.handleMenuAdd();
        break;
      case 'delete':
        this.handleMenuDelete();
        break;
      case 'clear':
        this.handleMenuClear();
        break;
      case 'copy_rating':
        this.handleMenuCopyRating();
        break;
      case 'paste':
        this.handleMenuPaste();
        break;
    }
  }

  handleMenuAdd = () => {
    let ratings = [ ...this.state.ratings ];
    ratings.push(50);

    this.setState({
      ratings: ratings,
    }, this.calculate);
  }

  handleMenuDelete = () => {
    if (this.state.ratings.length <= 1)
      return;

    let currentRating = this.state.currentRating;

    let ratings = [ ...this.state.ratings ];
    ratings.splice(currentRating, 1);

    if (currentRating >= ratings.length)
      currentRating = ratings.length-1;

    this.setState({
      currentRating: currentRating,
      ratings: ratings,
    }, this.calculate);
  }

  handleMenuClear = () => {
    this.setState(this.initialState, this.calculate);
  }

  handleMenuCopyRating = () => {
    this.copiedRating = this.state.ratings[this.state.currentRating];
  }

  handleMenuPaste = () => {
    if (this.copiedRating == undefined)
      return;

    let ratings = [ ...this.state.ratings ];
    ratings.push(this.copiedRating);

    this.setState({
      ratings: ratings,
    }, this.calculate);
  }

  // --------------------- Calculations ---------------------

  calculate = () => {
    if (!isValidDate(this.state.doi)) { return; }
    // console.log('Calculate');

    let ratings = [];
    for (let i = 0; i < this.state.ratings.length; ++i)
      ratings.push({ rating: this.state.ratings[i] });

    let combined = combineRatings(ratings, true);
    // console.log(`Combined value ${combined}%`);

    if (combined == 100) {
      this.setState({
        combinedValue: combined,
        amount: 0,
        warning: 'Check out our Future Value Calculator from the left menu!',
      });
    }
    else {
      this.setState({
        combinedValue: combined,
        warning: null,
      }, () => this.fetchPermDisResult(this.showResult));
    }
  }

  showResult = (result) => {
    // console.log(result);
    // permDisResult: { "aww":-1.0, "date":"1996-01-01T00:00:00.000+00:00", "disability":1, "minAWW":105.0, "maxAWW":210.0,
    //                  "minPDRate":70.0, "maxPDRate":140.0, "pdRate":140.0, "weeks":3.0, "amount":420.0}
    let pdRateText = result.pdRate <= result.minPDRate ? this.pdRateMinText :
                     result.pdRate >= result.maxPDRate ? this.pdRateMaxText : this.pdRateText;
    let newState = {
      pdRateText: pdRateText,
      pdRate: currencyFormatter.format(result.pdRate),
      amount: result.amount,
    };
    if (!this.state.inputAww || currencyFormatter.parse(this.state.aww) <= 0.0)
      newState.aww = currencyFormatter.format(result.maxAWW);
    this.setState(newState);
  }

  // --------------------- Rendering ---------------------
  render() {
    // console.log('CombinedValue.render()');

    const { classes } = this.props;

    return (
      <div style={{height: '100%'}}>
      <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <Grid container spacing={1} className={classes.root}>

        {/* Date of Injury */}
        <Grid item xs={4} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <DatePicker
              letiant="outlined"
              label="Date of Injury"
              minDate={ this.minDOI }
              maxDate={ this.maxDOI }
              value={ this.state.doi }
              onChange={ this.onDateOfInjuryChanged }
              format={ 'MM/dd/yyyy' }
            />
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Input AWW */}
          <Paper className={classes.wrapContent}>
            <FormControl margin='none' >
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputAww' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'AWW' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ 'Input AWW' } />
                  </ListItem>
                </List>
                <TextField
                  id="aww"
                  value={ this.state.aww }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ aww: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onAwwChanged(e.target.value) }
                  className={ classes.textField }
                  margin="dense"
                  InputProps={{
                    readOnly: false,
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* PD Rate */}
          <Paper className={classes.wrapContent}>
            <FormControl>
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputPdRate' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'PDRate' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ this.state.pdRateText } />
                  </ListItem>
                </List>
                <TextField
                  id="pdRate"
                  value={ this.state.pdRate }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ pdRate: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onPdRateChanged(e.target.value) }
                  className={ classes.textField }
                  margin="dense"
                  InputProps={{
                    readOnly: false,
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        {/* Ratings */}
        <Grid item xs={2} />
        <Grid item xs={8} className={classes.alignCenter}>
          <Paper className={classes.wrapContent1}>
            {/* List Ratings */}
            <List subheader="Permanent Disability">
              <div style={{ maxHeight: '35vh', overflow: 'auto' }}>
                <ComboBoxList items={ this.state.ratings }
                              comboBoxItems={ this.itemsWPI }
                              selectedIndex={ this.state.currentRating }
                              onComboBoxChanged={ this.onRatingChanged }
                              onIndexChanged={ this.onRatingIndexChanged } />
              </div>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={2} />

        <Grid item xs={6} className={classes.alignCenter}>
          {/* Combined Value */}
          <Paper className={classes.wrapContent}>
            <TextField
              id="combined"
              label="Combined Value"
              letiant="outlined"
              value={ this.state.combinedValue + '%' }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={6} className={classes.alignCenter}>
          {/* Amount */}
          <Paper className={classes.wrapContent}>
            <TextField
              error={ this.state.warning != null }
              id="amount"
              label="Amount"
              letiant="outlined"
              helperText={ this.state.warning }
              value={ currencyFormatter.format(this.state.amount) }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

      </Grid>
      </MuiPickersUtilsProvider>
      </div>
    );
  }

};

export default withStyles(styles)(withErrorHandling(CombinedValue));
